import MuiToolbar from '@material-ui/core/Toolbar';
import Typography from '@material-ui/core/Typography';
import Tab from '@material-ui/core/Tab';
import Tabs from '@material-ui/core/Tabs';
import ClaroLogoBlanco from 'assets/images/claro-logo-blanco.png';
import styled from 'styled-components';

export const StyledTabs = styled(Tabs)`
  display: flex;
  align-self: flex-end;
  .indicator {
    display: flex;
    justify-content: center;
  }
  .MuiTabs-indicator {
    display: none;
  }
`;

export const StyledTab = styled(Tab)(({ theme }) => ({
  ...theme.typography.body1,
  minWidth: '0px',
  letterSpacing: '0.09em',
  lineHeight: '1rem',
}));

export const StyledMenuContainer = styled.div`
  display: flex;
  align-items: center;
`;

export const StyledMenuProfileName = styled(Typography).attrs({
  variant: 'body2',
})`
  ${({ theme }) => `
    padding: ${theme.spacing(0, 2)};
    color: ${theme.palette.grey[200]};
  `}
`;
export const StyledRightMenu = styled.div`
  display: flex;
  align-items: center;
  justify-content: flex-end;
  gap: 10px;
`;

export const Logo = styled.img.attrs({
  src: ClaroLogoBlanco,
  alt: 'Claro Logo',
})`
  ${({ theme }) => `
    marginRight: ${theme.spacing(1)},
    marginBottom: ${theme.spacing(1)},
  `}
`;

export const Toolbar = styled(MuiToolbar)`
  display: inline-grid;
  grid-template-columns: 300px minmax(350px, 1fr) auto;
`;
